module.exports = __webpack_public_path__ + "media/images/project/drag-5d6dee672ab754c67a62ab46ab433b1c.svg";